<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลสินค้า
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row
          ><v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Material No') }"
          >
            <label>{{ $t('Material No') }}</label>
            <input
              :data-vv-as="$t('Material No')"
              v-validate="'required'"
              v-model="input.material_no"
              class="form-control"
              type="text"
              name="Material No"
            />
            <span class="text-error" v-if="errors.has('Material No')">{{
              errors.first('Material No')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Marketing Group') }"
          >
            <label>{{ $t('Marketing Group') }}</label>
            <input
              :data-vv-as="$t('Marketing Group')"
              v-validate="'required'"
              v-model="input.marketing_group"
              class="form-control"
              type="text"
              name="Marketing Group"
            />
            <span class="text-error" v-if="errors.has('Marketing Group')">{{
              errors.first('Marketing Group')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Sub Marketing Group') }"
          >
            <label>{{ $t('Sub Marketing Group') }}</label>
            <input
              :data-vv-as="$t('Sub Marketing Group')"
              v-validate="'required'"
              v-model="input.sub_marketing_group"
              class="form-control"
              type="text"
              name="Sub Marketing Group"
            />
            <span class="text-error" v-if="errors.has('Sub Marketing Group')">{{
              errors.first('Sub Marketing Group')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Product Name EN') }"
          >
            <label>{{ $t('Product Name EN') }}</label>
            <input
              :data-vv-as="$t('Product Name EN')"
              v-validate="'required'"
              v-model="input.product_name_en"
              class="form-control"
              type="text"
              name="Product Name EN"
            />
            <span class="text-error" v-if="errors.has('Product Name EN')">{{
              errors.first('Product Name EN')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Product Name TH') }"
          >
            <label>{{ $t('Product Name TH') }}</label>
            <input
              :data-vv-as="$t('Product Name TH')"
              v-validate="'required'"
              v-model="input.product_name_th"
              class="form-control"
              type="text"
              name="Product Name TH"
            />
            <span class="text-error" v-if="errors.has('Product Name TH')">{{
              errors.first('Product Name TH')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('Product Size') }"
          >
            <label>{{ $t('Product Size') }}</label>
            <input
              :data-vv-as="$t('Product Size')"
              v-validate="'required'"
              v-model="input.product_size"
              class="form-control"
              type="text"
              name="Product Size"
            />
            <span class="text-error" v-if="errors.has('Product Size')">{{
              errors.first('Product Size')
            }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('Score') }">
            <label>Score</label>
            <input
              data-vv-as="Score"
              v-validate="'required'"
              v-model="input.score"
              class="form-control"
              type="text"
              min="0"
              max="200000"
              name="Score"
              @keypress="keyIsNumber"
            />
            <span class="text-error" v-if="errors.has('Score')">{{ errors.first('Score') }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="savedata" depressed color="primary">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        material_no: '',
        marketing_group: '',
        sub_marketing_group: '',
        product_name_th: '',
        product_name_en: '',
        product_size: '',
        score: null
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = { ...this.editdata }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createData()
        } else {
          this.editProduct()
        }
      }
    },
    editProduct() {
      var data = {
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true
      api.updateProductToaecoupon(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createData() {
      var data = {
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true
      api.insertProductToaecoupon(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ProductEdit.vue